import { ITemplatesStore } from '../index'
import { IAcceptTemplates } from '../../../actions/templates/loadTemplates'

export default function(
  store: ITemplatesStore,
  action: IAcceptTemplates,
): ITemplatesStore {
  return { ...store, grouped: action.grouped, templates: action.templates }
}
